import React from "react";
// import { Link } from 'i18n/routing';
import { useConfig } from "hooks/use-config";
import { useMenuHoverConfig } from "hooks/use-menu-hover";
import { useMediaQuery } from "hooks/use-media-query";
import { Link } from "react-router-dom";
import { routes } from "router";
import StorboltLogo from "components/storbolt-logo";



const Logo = () => {
    const [config] = useConfig()
    const [hoverConfig] = useMenuHoverConfig();
    const { hovered } = hoverConfig
    const isDesktop = useMediaQuery('(min-width: 1024px)');

    if (config.sidebar === 'compact') {
        return <Link to={routes.Home.path} className="flex gap-2 items-center   justify-center    ">
            <StorboltLogo className="  text-default-900 h-8 w-8 [&>path:nth-child(3)]:text-background [&>path:nth-child(2)]:text-background" />

        </Link>
    }
    if (config.sidebar === 'two-column') return null
    const showName = !config?.collapsed || hovered || !isDesktop

    return (
        <Link to={routes.Home.path} className="flex gap-2 items-center    ">
            <StorboltLogo className="  text-default-900 h-8 w-8 [&>path:nth-child(3)]:text-background [&>path:nth-child(2)]:text-background" />
            {showName && (
                <h1 className="font-display text-xl font-semibold text-default-900 ">
                    Storbolt
                </h1>
            )}
        </Link>

    );
};

export default Logo;
